// Other context Factories
import DealerEntitiesFactory from '../../dealer/Entities/factory.js'
// Seller Factories
import {SellerEntitiesFactory} from '../Entities/factory.js'
import {SellerErrorsFactory} from '../Errors/factory.js'
import {SellerMappersFactory} from '../Mappers/factory.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'
import {SellerRequestsFactory} from '../Requests/factory.js'
import {SellerServicesFactory} from '../Services/factory.js'
import {SellerValueObjectsFactory} from '../ValueObjects/factory.js'
// Seller UseCases
import {ConfirmAppointmentWithDealerSellerUseCase} from './ConfirmAppointmentWithDealerSellerUseCase.js'
import {ContactModelSellerUseCase} from './ContactModelSellerUseCase.js'
import {GetCloseDealersSellerUseCase} from './GetCloseDealersSellerUseCase.js'
import {GetInstantOfferByAdSellerUseCase} from './GetInstantOfferByAdSellerUseCase.js'
import {GetInstantOfferByIdSellerUseCase} from './GetInstantOfferByIdSellerUseCase.js'
import {GetLastContactDetailsSellerUseCase} from './GetLastContactDetailsSellerUseCase.js'
import {GetRecommendedPriceSellerUseCase} from './GetRecommendedPriceSellerUseCase.js'
import {GetSellerUseCase} from './GetSellerUseCase.js'
import {GetSimulatedInstantOfferSellerUseCase} from './GetSimulatedInstantOfferSellerUseCase.js'
import {UpdateInstantOfferByIdSellerUseCase} from './UpdateInstantOfferByIdSellerUseCase.js'
export default class SellerUseCasesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @property {Function} appointmentSlotVOFactory
   * @property {Function} dealerEntityFactory
   * @property {Service} getInstantOfferByAdSellerService
   * @property {Function} instantOfferEntityFactory
   * @property {Function} invalidAppointmentRequestErrorFactory
   * @property {HTTPSellerRepository} repository
   * @return {ConfirmAppointmentWithDealerSellerUseCase}
   */
  static confirmAppointmentWithDealerSellerUseCase = ({config}) =>
    new ConfirmAppointmentWithDealerSellerUseCase({
      appointmentSlotVOFactory: SellerValueObjectsFactory.appointmentSlotSellerValueObject,
      dealerEntityFactory: DealerEntitiesFactory.dealerEntity,
      getInstantOfferByAdSellerService: SellerServicesFactory.getInstantOfferByAdSellerService({config}),
      instantOfferEntityFactory: SellerEntitiesFactory.instantOfferSellerEntity,
      invalidAppointmentRequestErrorFactory: SellerErrorsFactory.invalidAppointmentRequestSellerError,
      repository: SellerRepositoriesFactory.hTTPSellerRepository({config})
    })

  static contactModelSellerUseCase = ({config}) =>
    new ContactModelSellerUseCase({
      contactModelSellerRequest: SellerRequestsFactory.contactModelSellerRequest({
        config
      }),
      hTTPSellerRepository: SellerRepositoriesFactory.hTTPSellerRepository({
        config
      }),
      genericErrorFactory: SellerErrorsFactory.genericSellerError
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @property {Function} getCloseDealersRequestFactory
   * @property {Service} getInstantOfferByAdSellerService
   * @property {Function} instantOfferEntityFactory
   * @property {Function} invalidRequestErrorFactory
   * @property {HTTPSellerRepository} repository
   * @return {GetCloseDealersSellerUseCase}
   */
  static getCloseDealersSellerUseCase = ({config}) =>
    new GetCloseDealersSellerUseCase({
      getCloseDealersRequestFactory: SellerRequestsFactory.getCloseDealersRequest,
      getInstantOfferByAdSellerService: SellerServicesFactory.getInstantOfferByAdSellerService({config}),
      instantOfferEntityFactory: SellerEntitiesFactory.instantOfferSellerEntity,
      invalidRequestErrorFactory: SellerErrorsFactory.invalidRequestSellerError,
      repository: SellerRepositoriesFactory.hTTPSellerRepository({config})
    })

  static getLastContactDetailsSellerUseCase = ({config}) =>
    new GetLastContactDetailsSellerUseCase({
      getLastContactDetailsService: SellerServicesFactory.getLastContactDetailsSellerService({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetInstantOfferAdsUseCase}
   * @property {Service} getUserService
   * @property {RequestFactory} getInstantOfferRequestFactory
   * @property {HTTPAdsRepository} repository
   */
  static getInstantOfferByAdSellerUseCase = ({config}) =>
    new GetInstantOfferByAdSellerUseCase({
      getInstantOfferByAdSellerService: SellerServicesFactory.getInstantOfferByAdSellerService({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @property {function} instantOfferEntityFactory
   * @property {LocalStorageSellerRepository} localStorageRepository
   * @return {GetInstantOfferByIdSellerUseCase}
   */
  static getInstantOfferByIdSellerUseCase = ({config}) =>
    new GetInstantOfferByIdSellerUseCase({
      instantOfferEntityFactory: SellerEntitiesFactory.instantOfferSellerEntity,
      localStorageRepository: SellerRepositoriesFactory.localStorageSellerRepository({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @property {Mapper} rawParamsToGetSimulatedInstantOfferRequestMapper
   * @property {HTTPSellerRepository} httpRepository
   * @return {GetInstantOfferSellerUseCase}
   */
  static getSimulatedInstantOfferSellerUseCase = ({config}) =>
    new GetSimulatedInstantOfferSellerUseCase({
      rawParamsToGetSimulatedInstantOfferRequestMapper:
        SellerMappersFactory.rawParamsToGetSimulatedInstantOfferRequestSellerMapper({config}),
      httpRepository: SellerRepositoriesFactory.hTTPSellerRepository({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @property {Mapper} rawParamsToGetRecommendedPriceRequestMapper
   * @property {HTTPSellerRepository} httpRepository
   * @return {GetRecommendedPriceSellerUseCase}
   */
  static getRecommendedPriceSellerUseCase = ({config}) =>
    new GetRecommendedPriceSellerUseCase({
      httpRepository: SellerRepositoriesFactory.hTTPSellerRepository({config}),
      rawParamsToGetRecommendedPriceRequestMapper:
        SellerMappersFactory.rawParamsToGetRecommendedPriceRequestSellerMapper()
    })

  static getSellerUseCase = ({config}) =>
    new GetSellerUseCase({
      getSellerRequestMapper: SellerMappersFactory.getSellerRequestMapper({
        config
      }),
      service: SellerServicesFactory.getSellerService({config})
    })

  static updateInstantOfferByIdSellerUseCase = ({config}) => UpdateInstantOfferByIdSellerUseCase.create({config})
}
